import {
  AutoSplit,
  InventorySync,
  InventoryReordering,
  ProductBundles,
  ShippingStrategies,
  Cubiscan,
  ODBC,
  FulfillmentProviderBundle,
  DropShip,
  NonWalletProviderAccess,
  BrandedDomains,
  BrandedTracking,
  ShipStationFulfillmentWhiteLabel,
  InventoryApi,
  ShipStationApiV2,
  EnhancedReturns,
  LotTracking,
} from '../constants/features';

// NOTE: these are from dbo.Features, they are currently not defined in the same framework as the new features
// NOTE: some of these are dead and some of them may not be truthful if found on the seller (i.e. EnterpriseChatSupport)
export const LegacyFeatures = {
  CustomPackingSlips: 'CustomPackingSlips',
  LabelLogos: 'LabelLogos',
  ChatSupport: 'ChatSupport',
  GoogleCloudPrint: 'GoogleCloudPrint',
  OrderImport: 'OrderImport', // used for CSV import feature
  OrderAssignment: 'OrderAssignment',
  LocalPrinting: 'LocalPrinting',
  V2: 'V2',
  V1Lockout: 'V1Lockout',
  VerifiedEmail: 'VerifiedEmail',
  Inventory: 'Inventory',
  CustomDocs: 'CustomDocs',
  CustomExtracts: 'CustomExtracts',
  QuickShip: 'QuickShip', // changed to sellersetting, we can reuse this value later
  CloudSearch: 'CloudSearch',
  AutoBatching: 'AutoBatching',
  MultipleCarrierAccounts: 'MultipleCarrierAccounts',
  LabelApi: 'LabelApi',
  OpenApi: 'OpenApi',
  EnterpriseChatSupport: 'EnterpriseChatSupport',
};

export const PremiumFeatures = {
  AutoSplit,
  InventoryReordering,
  ProductBundles,
  ShippingStrategies,
  Cubiscan,
  ODBC,
  LotTracking,
};

// Features that cost extra and are not included in the HV plan
export const OtherFeatures = {
  FulfillmentProviderBundle,
  DropShip,
  NonWalletProviderAccess,
  WalletProviderAccess: 'WalletProviderAccess',
  BrandedDomains,
  BrandedTracking,
  InventorySync,
  CheckoutRatesByWeight: 'CheckoutRatesByWeight',
  CheckoutRatesByDimensions: 'CheckoutRatesByDimensions',
  ShipStationFulfillmentWhitelabel: ShipStationFulfillmentWhiteLabel,
  InventoryApi,
  ShipStationApiV2,
  EnhancedReturns,
};

export const NonPremiumFeatures = {
  ...LegacyFeatures,
  ...OtherFeatures,
};

export const SellerFeatures = {
  ...LegacyFeatures,
  ...PremiumFeatures,
  ...OtherFeatures,
};
